import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '../../constants/services';

const HomeServices = () => (
  <div className="home-services-grid">
    {SERVICES.map((service) => (
      <article key={service.title} className="home-service-card">
        <div className="home-service-card__media">
          <img src={service.image} alt={service.title} />
        </div>
        <div className="home-service-card__body">
          <h3 className="home-service-card__title">{service.title}</h3>
          <p className="home-service-card__text">{service.description}</p>
          <Link to={service.link} className="home-service-card__link">
            Learn more
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      </article>
    ))}
  </div>
);

export default HomeServices;
